import {connect} from '../../app/connect';
import TemplatesSearchDropdown from './TemplatesSearchDropdown';
import {getTemplatesQueryParams, getTemplatesSearchResults} from '../../app/selectors';
import {
  changeLocationAction,
  setQueryParamsAction,
  getTemplatesSearchResultsAction,
  clearTemplatesSearchResultsAction
} from '../../app/actions';

const mapStateToProps = state => ({
  queryParams: getTemplatesQueryParams(state),
  templatesSearchResults: getTemplatesSearchResults(state)
});

const mapDispatchToProps = {
  getTemplatesSearchResultsAction,
  clearTemplatesSearchResultsAction,
  setQueryParamsAction,
  changeLocationAction
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TemplatesSearchDropdown);
